import {post, reUrl} from '@/utils/request'

export default {
  login: (params, config) => {
    return post(reUrl + '/login', params, config)
  }
}



// WEBPACK FOOTER //
// ./src/api/login.js